module.exports = __webpack_public_path__ + "img/Apoint7.7c8c82c0.png";